const EN_TRANSLATE = {
    vietnamese: "Vietnamese",
    english: "English",
    Credit: "Credit",
    Private: "Private",
    Group: "Group",
    Login_LoginToYourAccount: 'Login to your account',
    Login_EnterEmail: 'Enter email',
    Login_Password: 'Password',
    Login_ForgotPassword: 'Forgot password?',
    Login_SignIn: 'Sign in',
    Login_NoAccount: "Don't have account yet?",
    Login_SignUp: 'Sign Up',
    Login_GetUserProfileError: 'Get user profile error !!',
    Login_Fail: 'Login failed',
    AuthApi_NoAccountFound: 'No account found with this email address',
    AuthApi_WrongPassword: 'Wrong password',
    AuthApi_AccountNotVerified: 'Account is not verified',
    AuthApi_ContactAdmin: 'Something has occurred, please contact Admin',
    Signup_CreateNewAccount: 'Create new account',
    Signup_FirstName: 'First Name',
    Signup_EnterFirstName: 'Enter first name',
    Signup_LastName: 'Last Name',
    Signup_EnterLastName: 'Enter last name',
    Signup_EmailAddress: 'Email address',
    Signup_EnterEmail: 'Enter email',
    Signup_Password: 'Password',
    Signup_PasswordPlaceholder: 'Password',
    Signup_ConfirmPassword: 'Confirm Password',
    Signup_ValidationLength: 'At least 8 characters',
    Signup_ValidationLowercase: 'At least one lowercase letter (a-z)',
    Signup_ValidationUppercase: 'At least one uppercase letter (A-Z)',
    Signup_ValidationNumber: 'At least one number (0-9)',
    Signup_ValidationSpecialChar: 'At least one special character (!@#...)',
    Signup_DateOfBirth: 'Date of Birth',
    Signup_DateOfBirthPlaceholder: 'Date of Birth',
    Signup_Gender: 'Gender',
    Signup_Male: 'Male',
    Signup_Female: 'Female',
    Signup_Phone: 'Phone',
    Signup_EnterPhone: 'Enter phone',
    Signup_AgreeMailingList:
        'I agree to subscribe to the mailing list for online course information',
    Signup_AgreeContact:
        'I consent to ASPRELY contacting me by phone, email, or SMS to address my inquiries/questions',
    Signup_AlreadyHaveAccount: 'Already have account?',
    Signup_SignIn: 'Sign in',
    Signup_NotifyMissingField: 'Missing required Field',
    Signup_NotifyPasswordMismatch: 'Password not match',
    Signup_NotifyAgreeTerms: 'You must agree to all terms and policies',
    Signup_NotifyRegisterSuccess: 'Register successfully',
    Signup_NotifyRegisterError: 'Register error, please try again',
    Signup_NotifyExistUser: 'User already exists',
    ForgotPass_Title: 'Forgot password',
    ForgotPass_Instruction:
        'Enter your email address and your password will be reset and emailed to you.',
    ForgotPass_EmailAddress: 'Email address',
    ForgotPass_EnterEmail: 'Enter email',
    ForgotPass_SendButton: 'Send me new password',
    ForgotPass_ForgetIt: 'Forget it,',
    ForgotPass_SendMeBack: 'Send me Back',
    ForgotPass_ToSignInScreen: 'to the Sign in screen.',
    ForgotPass_NotifySuccess: 'The email has been sent. Please check your mail',
    ForgotPass_NotifyNotFound: 'No account found with this email address',
    ForgotPass_NotifyError: 'Something has occurred, please contact Admin',
    Profile_Notify_UploadingAvatar: 'Uploading avatar...',
    Profile_Notify_AvatarUploaded: 'Avatar Uploaded!',
    Profile_Notify_AvatarUploadFailed: 'Avatar Upload Failed',
    Profile_Notify_CouldNotUpload: 'Could not upload image.',
    Profile_Notify_UpdateFailedInvalidRole: 'Update failed: Invalid user role.',
    Profile_Notify_UpdateSuccess: 'Update successfully',
    Profile_Notify_UpdateFailed: 'Update failed',
    Profile_Notify_PleaseTryAgain: 'Please try again.',
    Profile_Notify_PasswordChangeSuccess: 'Password change successfully',
    Profile_Notify_InvalidCurrentPassword: 'Invalid current password',
    Profile_Notify_PasswordChangeError: 'Something has occurred, please contact Admin',
    Profile_Table_Description: 'Description',
    Profile_Table_StartDate: 'Start Date',
    Profile_Table_EndDate: 'End Date',
    Profile_Table_Teacher: 'Teacher',
    Profile_Table_Attended: 'Attended',
    Profile_Table_Remaining: 'Remaining',
    Profile_Title: 'My Profile',
    Profile_Breadcrumb_Pages: 'Pages',
    Profile_Tab_Profile: 'Profile',
    Profile_EditProfile_Title: 'Edit Profile',
    Profile_EditProfile_Avatar: 'Avatar',
    Profile_EditProfile_FirstName: 'First name',
    Profile_EditProfile_LastName: 'Last name',
    Profile_EditProfile_Email: 'Email address',
    Profile_EditProfile_Phone: 'Phone number',
    Profile_EditProfile_Gender: 'Gender',
    Profile_EditProfile_Male: 'Male',
    Profile_EditProfile_Female: 'Female',
    Profile_EditProfile_Token: 'Credit',
    Profile_EditProfile_TokenPurchased: 'Credit purchased',
    Profile_EditProfile_UpdateBtn: 'Update Profile',
    Profile_ChangePass_Current: 'Current Password',
    Profile_ChangePass_New: 'Password',
    Profile_ChangePass_Confirm: 'Confirm Password',
    Profile_ChangePass_Placeholder: 'Password',
    Profile_ChangePass_Button: 'Change password',
    Profile_Validation_Length: 'At least 8 characters',
    Profile_Validation_Lowercase: 'At least one lowercase letter (a-z)',
    Profile_Validation_Uppercase: 'At least one uppercase letter (A-Z)',
    Profile_Validation_Number: 'At least one number (0-9)',
    Profile_Validation_SpecialChar: 'At least one special character (!@#...)',
    Header_LanguageFlag: 'Language',
    Header_Profile: 'Profile',
    Header_SignOut: 'Sign out',
    Sidebar_LogoAlt: 'logo',
    Sidebar_BrandName: 'Aspirely',
    Sidebar_University: 'University',
    Sidebar_Admin: 'Admin',
    Calendar_Title: 'Calendar',
    Calendar_BrandName: 'Aspirely',
    Calendar_Credit: 'Credit',
    Course_Student_List_Title: 'Courses',
    Course_Student_List_BrandName: 'Aspirely',
    Course_Student_List_Credit: 'Credit',
    Course_Student_List_CourseImageAlt: 'Course image',
    Course_Student_Edit_Title: 'Course Details',
    Course_Student_Edit_BrandName: 'Aspirely',
    Course_Student_Edit_Courses: 'Courses',
    Course_Student_Edit_Details: 'Details',
    Course_Student_Edit_Date: 'Date',
    Course_Student_Edit_Duration: 'Duration',
    Course_Student_Edit_Students: 'Students',
    Course_Student_Edit_ImageAlt: 'Course image',
    Course_Student_Edit_TeacherAvatarAlt: 'Teacher avatar',
    Course_Student_Edit_EnrollButton: 'Enroll Course',
    Course_Student_Edit_EnrollSuccess: 'Enrolled successfully',
    Course_Student_Edit_Syllabus: 'Course Syllabus',
    Teacher_Admin_List_Delete_SelectReplacement: 'Select replacement teacher',
    Teacher_Admin_List_Delete_AvatarAlt: 'Teacher Avatar',
    Teacher_Admin_List_Delete_Title: 'Are you sure?',
    Teacher_Admin_List_Delete_Text: 'You will not be able to recover this teacher!',
    Teacher_Admin_List_Delete_ValidationMessage:
        "Select a replacement teacher for this teacher's courses!",
    Teacher_Admin_List_Delete_ConfirmButton: 'Yes, delete it!',
    Teacher_Admin_List_Delete_CancelButton: 'No, cancel!',
    Teacher_Admin_List_Delete_SuccessMessage: 'Delete successful!',
    Teacher_Admin_List_Table_Name: 'Name',
    Teacher_Admin_List_Table_Subject: 'Subject',
    Teacher_Admin_List_Table_Major: 'Major',
    Teacher_Admin_List_Table_Experience: 'Experience',
    Teacher_Admin_List_Table_OnboardingDate: 'Onboarding Date',
    Teacher_Admin_List_EditButton: 'Edit',
    Teacher_Admin_List_DeleteButton: 'Delete',
    Teacher_Admin_List_PageTitle: 'Teachers',
    Teacher_Admin_List_Breadcrumb_Brand: 'Aspirely',
    Teacher_Admin_List_Breadcrumb_Active: 'Teachers',
    Teacher_Admin_List_CreateButton: 'Create',
    Teacher_Admin_Edit_Load_Failed_Message: 'Failed to Load Teacher',
    Teacher_Admin_Edit_Load_Failed_Description: 'Could not fetch teacher details.',
    Teacher_Admin_Edit_Avatar_Uploading_Message: 'Uploading avatar...',
    Teacher_Admin_Edit_Avatar_Success_Message: 'Avatar Uploaded!',
    Teacher_Admin_Edit_Avatar_Failed_Message: 'Avatar Upload Failed',
    Teacher_Admin_Edit_Avatar_Failed_Description: 'Could not upload image.',
    Teacher_Admin_Edit_Submit_UpdateSuccess_Message: 'Update successfully',
    Teacher_Admin_Edit_Submit_CreateSuccess_Message: 'Create successfully',
    Teacher_Admin_Edit_Submit_UpdateFailed_Message: 'Update Failed',
    Teacher_Admin_Edit_Submit_CreateFailed_Message: 'Create Failed',
    Teacher_Admin_Edit_Submit_Failed_Description: 'Please check your input and try again.',
    Teacher_Admin_Edit_Validation_MissingFields_Message: 'Missing Required Fields',
    Teacher_Admin_Edit_Validation_MissingFields_Description:
        'Please fill in all required fields marked with *.',
    Teacher_Admin_Edit_PageTitle_Edit: 'Edit Teacher',
    Teacher_Admin_Edit_PageTitle_Create: 'Create Teacher',
    Teacher_Admin_Edit_Breadcrumb_Brand: 'Aspirely',
    Teacher_Admin_Edit_Breadcrumb_Teachers: 'Teachers',
    Teacher_Admin_Edit_Breadcrumb_Active_Edit: 'Edit',
    Teacher_Admin_Edit_Breadcrumb_Active_Create: 'Create',
    Teacher_Admin_Edit_CardTitle_BasicInfo: 'Basic Information',
    Teacher_Admin_Edit_Form_Avatar: 'Avatar',
    Teacher_Admin_Edit_Form_FirstName: 'First Name',
    Teacher_Admin_Edit_Form_FirstName_Placeholder: 'Enter first name',
    Teacher_Admin_Edit_Form_LastName: 'Last Name',
    Teacher_Admin_Edit_Form_LastName_Placeholder: 'Enter last name',
    Teacher_Admin_Edit_Form_Phone: 'Phone',
    Teacher_Admin_Edit_Form_Phone_Placeholder: 'Enter phone number',
    Teacher_Admin_Edit_Form_Email: 'Email',
    Teacher_Admin_Edit_Form_Email_Placeholder: 'Enter email address',
    Teacher_Admin_Edit_Form_DOB: 'Date of Birth',
    Teacher_Admin_Edit_Form_Date_Placeholder: 'Select date',
    Teacher_Admin_Edit_Form_Gender: 'Gender',
    Teacher_Admin_Edit_Form_Gender_Male: 'Male',
    Teacher_Admin_Edit_Form_Gender_Female: 'Female',
    Teacher_Admin_Edit_Form_Subject: 'Subject',
    Teacher_Admin_Edit_Form_Subject_Placeholder: 'e.g., Mathematics',
    Teacher_Admin_Edit_Form_Major: 'Major',
    Teacher_Admin_Edit_Form_Major_Placeholder: 'e.g., Calculus',
    Teacher_Admin_Edit_Form_Experience: 'Experience',
    Teacher_Admin_Edit_Form_Experience_Placeholder: 'e.g., 5 years',
    Teacher_Admin_Edit_Form_OnboardingDate: 'Onboarding Date',
    Teacher_Admin_Edit_Form_Bio: 'Bio',
    Teacher_Admin_Edit_Form_Bio_Placeholder: 'Enter teacher biography',
    Teacher_Admin_Edit_CardTitle_AccountInfo: 'Account Information',
    Teacher_Admin_Edit_Form_Password: 'Password',
    Teacher_Admin_Edit_Form_Password_Placeholder_Edit: 'Leave blank to keep current',
    Teacher_Admin_Edit_Form_Password_Placeholder_Create: 'Enter password',
    Teacher_Admin_Edit_Form_ConfirmPassword: 'Confirm Password',
    Teacher_Admin_Edit_Form_ConfirmPassword_Validation: 'The passwords do not match',
    Teacher_Admin_Edit_Form_ConfirmPassword_Placeholder: 'Confirm password',
    Teacher_Admin_Edit_Button_Saving: 'Saving...',
    Teacher_Admin_Edit_Button_Submit: 'Submit',
    Teacher_Admin_Edit_Button_Cancel: 'Cancel',
    Student_Admin_List_Delete_Title: 'Are you sure?',
    Student_Admin_List_Delete_Text: "You won't be able to revert this!",
    Student_Admin_List_Delete_ConfirmButton: 'Yes, delete it!',
    Student_Admin_List_Delete_SuccessTitle: 'Deleted!',
    Student_Admin_List_Delete_SuccessText: 'The student has been deleted.',
    Student_Admin_List_Table_Name: 'Name',
    Student_Admin_List_Table_Email: 'Email',
    Student_Admin_List_Table_Phone: 'Phone',
    Student_Admin_List_Table_DOB: 'Date of Birth',
    Student_Admin_List_Table_Gender: 'Gender',
    Student_Admin_List_Table_Status: 'Status',
    Student_Admin_List_Button_Edit: 'Edit',
    Student_Admin_List_Button_Delete: 'Delete',
    Student_Admin_List_PageTitle: 'Students',
    Student_Admin_List_Breadcrumb_Brand: 'Aspirely',
    Student_Admin_List_Breadcrumb_Active: 'Students',
    Student_Admin_List_Filter_Name_Placeholder: 'Name',
    Student_Admin_List_Filter_Email_Placeholder: 'Email',
    Student_Admin_List_Filter_Status_Placeholder: 'Select status',
    Student_Admin_List_Filter_Status_NotTested: 'Not tested',
    Student_Admin_List_Filter_Status_Tested: 'Tested',
    Student_Admin_List_Filter_Status_Studying: 'Studying',
    Student_Admin_List_Filter_Status_Completed: 'Completed',
    Student_Admin_List_Filter_Status_Inactive: 'Inactive',
    Student_Admin_List_Filter_Button_Search: 'Search',
    Student_Admin_List_Button_Create: 'Create',
    Student_Admin_Edit_Submit_UpdateSuccess: 'Update successfully',
    Student_Admin_Edit_Submit_CreateSuccess: 'Create successfully',
    Student_Admin_Edit_Validation_GeneralError:
        'Please fill in all required fields before submitting.',
    Student_Admin_Edit_Validation_AvatarError: 'Please upload a required avatar.',
    Student_Admin_Edit_Validation_MissingFieldsTitle: 'Missing Required Fields',
    Student_Admin_Edit_Avatar_Uploading: 'Uploading avatar...',
    Student_Admin_Edit_Avatar_Success: 'Avatar Uploaded!',
    Student_Admin_Edit_Avatar_FailedTitle: 'Avatar Upload Failed',
    Student_Admin_Edit_Avatar_FailedDescription: 'Could not upload image.',
    Student_Admin_Edit_BasicInfo_Title: 'Basic Information',
    Student_Admin_Edit_Form_FirstName: 'First Name',
    Student_Admin_Edit_Validation_FirstNameRequired: 'First name is required',
    Student_Admin_Edit_Form_FirstNamePlaceholder: 'Enter First name',
    Student_Admin_Edit_Form_LastName: 'Last Name',
    Student_Admin_Edit_Validation_LastNameRequired: 'Last name is required',
    Student_Admin_Edit_Form_LastNamePlaceholder: 'Enter Last name',
    Student_Admin_Edit_Form_Gender: 'Gender',
    Student_Admin_Edit_Form_GenderMale: 'Male',
    Student_Admin_Edit_Form_GenderFemale: 'Female',
    Student_Admin_Edit_Form_Email: 'Email',
    Student_Admin_Edit_Validation_EmailRequired: 'Email is required',
    Student_Admin_Edit_Validation_EmailInvalid: 'Invalid email address',
    Student_Admin_Edit_Form_DOB: 'Date of birth',
    Student_Admin_Edit_Validation_DOBRequired: 'Date of birth is required',
    Student_Admin_Edit_Form_DOBPlaceholder: 'MM/DD/YYYY',
    Student_Admin_Edit_Form_Phone: 'Phone number',
    Student_Admin_Edit_Validation_PhoneRequired: 'Phone number is required',
    Student_Admin_Edit_Form_Status: 'Status',
    Student_Admin_Edit_Status_NotTested: 'Not tested',
    Student_Admin_Edit_Status_Tested: 'Tested',
    Student_Admin_Edit_Status_Studying: 'Studying',
    Student_Admin_Edit_Status_Completed: 'Completed',
    Student_Admin_Edit_Status_Inactive: 'Inactive',
    Student_Admin_Edit_Form_TestType: 'Test type',
    Student_Admin_Edit_Form_Feedback: 'Feedback',
    Student_Admin_Edit_Form_FeedbackPlaceholder: "Enter comments about the student's test",
    Student_Admin_Edit_AccountInfo_Title: 'Account Information',
    Student_Admin_Edit_Form_UserName: 'User Name',
    Student_Admin_Edit_Form_Password: 'Password',
    Student_Admin_Edit_Validation_PasswordRequired: 'Password is required',
    Student_Admin_Edit_Form_ConfirmPassword: 'Confirm Password',
    Student_Admin_Edit_Token_Title: 'Credit',
    Student_Admin_Edit_Token_Table_Type: 'Credit Type',
    Student_Admin_Edit_Token_Table_Amount: 'Amount',
    Student_Admin_Edit_TokenPurchased_Title: 'Credit purchased',
    Student_Admin_Edit_TokenPurchased_Table_Type: 'Credit Type',
    Student_Admin_Edit_TokenPurchased_Table_Amount: 'Amount',
    Student_Admin_Edit_TokenTopUp_Type: 'Credit Type',
    Student_Admin_Edit_TokenTopUp_TypePlaceholder: 'Select type...',
    Student_Admin_Edit_TokenTopUp_Quantity: 'Quantity',
    Student_Admin_Edit_TokenTopUp_Validation_Type: 'Please select a credit type.',
    Student_Admin_Edit_TokenTopUp_Validation_AmountTitle: 'Invalid Quantity',
    Student_Admin_Edit_TokenTopUp_Validation_AmountDescription: 'Quantity must be greater than 0.',
    Student_Admin_Edit_TokenTopUp_Success: 'Topup success',
    Student_Admin_Edit_TokenTopUp_Failed: 'Something has occurred, please try again',
    Student_Admin_Edit_TokenTopUp_Button: 'Topup',
    Student_Admin_Edit_Button_Submit: 'Submit',
    Student_Admin_Edit_Button_Cancel: 'Cancel',
    Course_Admin_List_Delete_Title: 'Are you sure?',
    Course_Admin_List_Delete_Text: 'You will not be able to recover this course!',
    Course_Admin_List_Delete_ConfirmButton: 'Yes, delete it!',
    Course_Admin_List_Delete_CancelButton: 'No, cancel!',
    Course_Admin_List_Delete_SuccessMessage: 'Delete successfully!',
    Course_Admin_List_Table_Title: 'Title',
    Course_Admin_List_Table_Description: 'Description',
    Course_Admin_List_Table_StartDate: 'Start Date',
    Course_Admin_List_Table_EndDate: 'End Date',
    Course_Admin_List_Table_Action: 'Action',
    Course_Admin_List_Button_Edit: 'Edit',
    Course_Admin_List_Button_Delete: 'Delete',
    Course_Admin_List_PageTitle: 'Courses',
    Course_Admin_List_Breadcrumb_Brand: 'Aspirely',
    Course_Admin_List_Breadcrumb_Active: 'Courses',
    Course_Admin_List_Button_Create: 'Create',
    Course_Admin_Edit_Upload_FileError: 'You can only upload JPG/PNG file!',
    Course_Admin_Edit_Upload_SizeError: 'Image must smaller than 2MB!',
    Course_Admin_Edit_Lesson_LoadFailed_Title: 'Failed to Load Lessons',
    Course_Admin_Edit_Lesson_LoadFailed_Description: 'Could not fetch the lesson list.',
    Course_Admin_Edit_TokenType_LoadFailed_Title: 'Failed to Load Credit Types',
    Course_Admin_Edit_TokenType_LoadFailed_Description: 'Could not fetch credit types.',
    Course_Admin_Edit_Detail_LoadFailed_Title: 'Failed to Load Course Details',
    Course_Admin_Edit_Detail_LoadFailed_Description: 'Could not fetch course details.',
    Course_Admin_Edit_Validation_SelectTeacher: 'Please select a Teacher.',
    Course_Admin_Edit_Validation_SelectProgram: 'Please select a Program.',
    Course_Admin_Edit_Submit_UpdateSuccess: 'Update successfully',
    Course_Admin_Edit_Submit_CreateSuccess: 'Create successfully',
    Course_Admin_Edit_Submit_UpdateFailed: 'Update Failed',
    Course_Admin_Edit_Submit_CreateFailed: 'Create Failed',
    Course_Admin_Edit_Submit_FailedDescription: 'Please check your input and try again.',
    Course_Admin_Edit_Validation_MissingFields_Title: 'Missing Required Fields',
    Course_Admin_Edit_Validation_MissingFields_Description:
        'Please fill in all required fields marked with *.',
    Course_Admin_Edit_Thumbnail_Uploading: 'Uploading thumbnail...',
    Course_Admin_Edit_Thumbnail_UploadSuccess: 'Thumbnail Uploaded!',
    Course_Admin_Edit_Thumbnail_UploadFailed_Title: 'Thumbnail Upload Failed',
    Course_Admin_Edit_Thumbnail_UploadFailed_Description: 'Could not upload Thumbnail.',
    Course_Admin_Edit_Lesson_Delete_Title: 'Are you sure?',
    Course_Admin_Edit_Lesson_Delete_Text: 'You will not be able to recover this lesson!',
    Course_Admin_Edit_Lesson_Delete_ConfirmButton: 'Yes, delete it!',
    Course_Admin_Edit_Lesson_Delete_CancelButton: 'No, cancel!',
    Course_Admin_Edit_Lesson_Delete_SuccessMessage: 'Delete successfully!',
    Course_Admin_Edit_Lesson_Delete_Failed_Title: 'Delete Failed',
    Course_Admin_Edit_Lesson_Delete_Failed_Description: 'Could not delete lesson.',
    Course_Admin_Edit_Lesson_Table_Description: 'Description',
    Course_Admin_Edit_Lesson_Table_StartDate: 'Start Date',
    Course_Admin_Edit_Lesson_Table_EndDate: 'End Date',
    Course_Admin_Edit_Lesson_Table_Action: 'Action',
    Course_Admin_Edit_Lesson_Table_EditButton: 'Edit',
    Course_Admin_Edit_Lesson_Table_DeleteButton: 'Delete',
    Course_Admin_Edit_Enrollment_Unenroll_Title: 'Unenroll student',
    Course_Admin_Edit_Enrollment_Unenroll_Refund_Content:
        'Do you want to refund credit for this student?',
    Course_Admin_Edit_Enrollment_Unenroll_Refund_Ok: 'Yes, Refund',
    Course_Admin_Edit_Enrollment_Unenroll_Refund_Cancel: 'No, Just Unenroll',
    Course_Admin_Edit_Enrollment_Table_FirstName: 'First Name',
    Course_Admin_Edit_Enrollment_Table_LastName: 'Last Name',
    Course_Admin_Edit_Enrollment_Table_Email: 'Email',
    Course_Admin_Edit_Enrollment_Table_Status: 'Status',
    Course_Admin_Edit_Enrollment_Table_Action: 'Action',
    Course_Admin_Edit_Enrollment_Unenroll_Description:
        'Are you sure you want to unenroll this student?',
    Course_Admin_Edit_Enrollment_Unenroll_Confirm: 'Yes',
    Course_Admin_Edit_Enrollment_Unenroll_Cancel: 'No',
    Course_Admin_Edit_Enrollment_Table_DeleteButton: 'Delete',
    Course_Admin_Edit_Enrollment_Title: 'Enrolled Students',
    Course_Admin_Edit_PageTitle_Edit: 'Edit Course',
    Course_Admin_Edit_PageTitle_Create: 'Create Course',
    Course_Admin_Edit_Breadcrumb_Brand: 'Aspirely',
    Course_Admin_Edit_Breadcrumb_Courses: 'Courses',
    Course_Admin_Edit_Breadcrumb_Active_Edit: 'Detail',
    Course_Admin_Edit_Breadcrumb_Active_Create: 'Create',
    Course_Admin_Edit_CardTitle_BasicInfo: 'Basic Information',
    Course_Admin_Edit_Thumbnail_Alt: 'thumbnail',
    Course_Admin_Edit_Form_Title: 'Title',
    Course_Admin_Edit_Form_Title_Placeholder: 'Enter course title',
    Course_Admin_Edit_Form_StartDate: 'Start Date',
    Course_Admin_Edit_Form_StartDate_Placeholder: 'Select start date',
    Course_Admin_Edit_Form_EndDate: 'End Date',
    Course_Admin_Edit_Form_EndDate_Placeholder: 'Select end date',
    Course_Admin_Edit_Form_TotalSlot: 'Total Slot',
    Course_Admin_Edit_Form_TotalSlot_Placeholder: 'e.g., 10',
    Course_Admin_Edit_Form_TokenCost: 'Price (Credits)',
    Course_Admin_Edit_Form_TokenCost_Placeholder: 'e.g., 5',
    Course_Admin_Edit_Form_TotalLessons: 'Total Lessons',
    Course_Admin_Edit_Form_TotalLessons_Placeholder: 'e.g., 8',
    Course_Admin_Edit_Form_TokenType: 'Credit type',
    Course_Admin_Edit_Form_TokenType_Loading: 'Loading...',
    Course_Admin_Edit_Form_TokenType_Select: 'Select Type',
    Course_Admin_Edit_Form_Teacher: 'Teacher',
    Course_Admin_Edit_Form_Teacher_Select: 'Click to select',
    Course_Admin_Edit_Form_Teacher_Placeholder: 'Select a teacher',
    Course_Admin_Edit_Form_Program: 'Program',
    Course_Admin_Edit_Form_Program_Select: 'Click to select',
    Course_Admin_Edit_Form_Program_Placeholder: 'Select a program',
    Course_Admin_Edit_Form_Description: 'Description',
    Course_Admin_Edit_Form_Description_Placeholder: 'Enter course description (optional)',
    Course_Admin_Edit_Button_Saving: 'Saving...',
    Course_Admin_Edit_Button_Submit: 'Submit',
    Course_Admin_Edit_Button_Cancel: 'Cancel',
    Course_Admin_Edit_Lesson_Title: 'Lessons',
    Course_Admin_Edit_Lesson_AddButton: 'Add Lesson',
    Course_Admin_Edit_Lesson_AddButton_Noti: 'Please specify teacher before create lesson',
    Course_Admin_Edit_Pagination: '{{start}}-{{end}} of {{total}} items',
    Program_Admin_List_Delete_Title: 'Are you sure?',
    Program_Admin_List_Delete_Text: 'You will not be able to recover this program!',
    Program_Admin_List_Delete_ConfirmButton: 'Yes, delete it!',
    Program_Admin_List_Delete_CancelButton: 'No, cancel!',
    Program_Admin_List_Delete_SuccessMessage: 'Delete successfully!',
    Program_Admin_List_Table_Name: 'Name',
    Program_Admin_List_Table_Description: 'Description',
    Program_Admin_List_Table_Action: 'Action',
    Program_Admin_List_Button_Edit: 'Edit',
    Program_Admin_List_Button_Delete: 'Delete',
    Program_Admin_List_PageTitle: 'Programs',
    Program_Admin_List_Breadcrumb_Brand: 'Aspirely',
    Program_Admin_List_Breadcrumb_Active: 'Programs',
    Program_Admin_List_Button_Create: 'Create',
    Program_Admin_Edit_Load_Failed_Message: 'Failed to Load Program Details',
    Program_Admin_Edit_Load_Failed_Description: 'Could not fetch program details.',
    Program_Admin_Edit_Validation_MissingFields_Message: 'Missing Required Fields',
    Program_Admin_Edit_Validation_MissingFields_Description:
        'Please fill in all required fields marked with *.',
    Program_Admin_Edit_Submit_UpdateSuccess_Message: 'Update successfully',
    Program_Admin_Edit_Submit_CreateSuccess_Message: 'Create successfully',
    Program_Admin_Edit_Submit_UpdateFailed_Message: 'Update Failed',
    Program_Admin_Edit_Submit_CreateFailed_Message: 'Create Failed',
    Program_Admin_Edit_Submit_Failed_Description: 'Please try again.',
    Program_Admin_Edit_PageTitle_Edit: 'Edit Program',
    Program_Admin_Edit_PageTitle_Create: 'Create Program',
    Program_Admin_Edit_Breadcrumb_Brand: 'Aspirely',
    Program_Admin_Edit_Breadcrumb_Programs: 'Programs',
    Program_Admin_Edit_Breadcrumb_Active_Edit: 'Detail',
    Program_Admin_Edit_Breadcrumb_Active_Create: 'Create',
    Program_Admin_Edit_CardTitle_BasicInfo: 'Basic Information',
    Program_Admin_Edit_Form_Name: 'Name',
    Program_Admin_Edit_Form_Name_Placeholder: 'Enter program name',
    Program_Admin_Edit_Form_Description: 'Description',
    Program_Admin_Edit_Form_Description_Placeholder: 'Enter program description',
    Program_Admin_Edit_Button_Saving: 'Saving...',
    Program_Admin_Edit_Button_Submit: 'Submit',
    Program_Admin_Edit_Button_Cancel: 'Cancel',
    LessonModal_Admin_Fetch_Failed_Title: 'Fetch Failed',
    LessonModal_Admin_Fetch_Failed_Description: 'Could not load lesson details. Please try again.',
    LessonModal_Admin_Validation_MissingFields_Title: 'Missing Required Fields',
    LessonModal_Admin_Validation_MissingFields_Description:
        'Please fill in all required fields marked with *.',
    LessonModal_Admin_Submit_UpdateSuccess: 'Update successfully',
    LessonModal_Admin_Submit_UpdateFailed_Title: 'Update Failed',
    LessonModal_Admin_Submit_Failed_Description: 'Please try again.',
    LessonModal_Admin_Submit_CreateSuccess: 'Create successfully',
    LessonModal_Admin_Submit_CreateFailed_Title: 'Create Failed',
    LessonModal_Admin_Submit_Failed_Description_Create: 'Please check your input and try again.',
    LessonModal_Admin_Title_Edit: 'Edit Lesson',
    LessonModal_Admin_Title_Create: 'Create Lesson',
    LessonModal_Admin_Button_Cancel: 'Cancel',
    LessonModal_Admin_Button_Ok: 'Ok',
    LessonModal_Admin_Form_Description: 'Description',
    LessonModal_Admin_Form_StartDate: 'Start Date',
    LessonModal_Admin_Form_StartDate_Placeholder: 'Select start date',
    LessonModal_Admin_Form_EndDate: 'End Date',
    LessonModal_Admin_Form_EndDate_Placeholder: 'Select end date',
    LessonModal_Admin_Form_Link: 'Meeting Link',
    LessonModal_Admin_Form_Link_Placeholder: 'Enter meeting link (e.g., Zoom, Google Meet)',
    LessonModal_Student_Upload_Success_Title: 'Video Uploaded!',
    LessonModal_Student_Upload_Failed_Title: 'Video Upload Failed',
    LessonModal_Student_Upload_Failed_Description: 'Could not upload video.',
    LessonModal_Student_Update_Success_Title: 'Update successfully',
    LessonModal_Student_Update_Failed_Title: 'Update Failed',
    LessonModal_Student_Update_Failed_Description: 'Please try again.',
    LessonModal_Student_Button_Cancel: 'Cancel',
    LessonModal_Student_Button_Ok: 'Ok',
    LessonModal_Student_Button_Upload: 'Upload',
    LessonModal_Student_Enroll_Prompt: 'Please enroll in the course to view the lesson content!',
    LessonModal_Student_NoRecord_Prompt: 'There is no record yet, please check back later!',
    ProgramModal_Title: 'Select Program',
    ProgramModal_Button_Ok: 'OK',
    ProgramModal_Button_Cancel: 'Cancel',
    TeacherModal_Title: 'Select Teacher',
    TeacherModal_Button_Ok: 'OK',
    TeacherModal_Button_Cancel: 'Cancel',
    TeacherModal_Avatar_Alt: 'Teacher Avatar',
    Menu_Dashboard: 'Dashboard',
    Menu_Teachers: 'Teachers',
    Menu_Students: 'Students',
    Menu_Courses: 'Courses',
    Menu_Programs: 'Programs',
    Dashboard_Event_Modal_Title: 'Event Details',
    Dashboard_Event_Modal_Button_Close: 'Close',
    Dashboard_Event_Modal_Button_Join: 'Join Meeting',
    Dashboard_Event_Modal_Label_Course: 'Course',
    Dashboard_Event_Modal_Label_Description: 'Description',
    Dashboard_Event_Modal_Label_Start: 'Start',
    Dashboard_Event_Modal_Label_End: 'End',
    Dashboard_Event_Modal_Label_Duration: 'Duration',
    Dashboard_Event_Modal_Label_Minutes: 'minutes',
    Course_Admin_Edit_Lesson_Unenroll_Success_Description: 'Unenroll successfully',
    Course_Admin_Edit_Lesson_Unenroll_Error_Description: 'Unenroll fail, please try again'
};

export default EN_TRANSLATE;
